"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
exports.urlStore = function (locationSearch) {
    var params = new URLSearchParams(locationSearch);
    var store = utils_1.safeParseJSON(params.get(utils_1.KEY_PREFIX) || {});
    return {
        name: 'urlStore',
        get: function (flagName) { return store[flagName] || null; },
        all: function () { return store; }
    };
};
//# sourceMappingURL=url-store.js.map